import { render, staticRenderFns } from "./UnreadBadge.vue?vue&type=template&id=3f00ad38&scoped=true"
import script from "./UnreadBadge.vue?vue&type=script&lang=js"
export * from "./UnreadBadge.vue?vue&type=script&lang=js"
import style0 from "./UnreadBadge.vue?vue&type=style&index=0&id=3f00ad38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00ad38",
  null
  
)

export default component.exports